import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { NGXLogger } from 'ngx-logger';

interface JwtPayload {
  sub: string;
  exp: number;
  iat: number;
  cid: string;
  uid: string;
  alr: number;
  alw: number;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor(private logger: NGXLogger) { }

  private decodeToken(): JwtPayload | null {
    const token = window.localStorage.getItem('puzzel_token');
    if (!token) {
      return null;
    }
    try {
      return jwtDecode<JwtPayload>(token);
    } catch (error) {
      this.logger.warn('Failed to decode JWT token', error);
      return null;
    }
  }

  get userId(): string | null {
    return this.decodeToken()?.uid ?? null;
  }

  get customerKey(): string | null {
    return this.decodeToken()?.cid ?? null;
  }
}
